// ============================================================================
// RABIN-KARP - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'rabin-karp',
  name: 'Rabin-Karp',
  category: 'Strings',
  complexity: {
    time: 'O((N-M+1)M) average, O(NM) worst',
    space: 'O(1)'
  },
  description: 'A string searching algorithm that uses hashing to find pattern matches. It computes rolling hashes of the text and compares them with the pattern hash, making it efficient for multiple pattern search.'
};
